import { render, staticRenderFns } from "./LKPublicationsFormdataHistoryListModal.vue?vue&type=template&id=3b266ef8&"
import script from "./LKPublicationsFormdataHistoryListModal.vue?vue&type=script&lang=js&"
export * from "./LKPublicationsFormdataHistoryListModal.vue?vue&type=script&lang=js&"
import style0 from "./LKPublicationsFormdataHistoryListModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports